import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from '../utils/siteUtils.js';
import '../styles/Home.css';
export class NotificationMessage extends Component {

    constructor(props) {
        super(props);
        this.dismissAlert = this.dismissAlert.bind(this);
       
        this.state = {
            isOpen: false,            
            notification: {},
        };
    }

    componentDidMount() {       
        this.getNotification();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentNotificationId !== this.props.currentNotificationId ||
            prevProps.currentCompanyId !== this.props.currentCompanyId) {
            this.getNotification();
        }
    }


    getNotification() {
        const { currentCompanyId, currentUser } = this.props;
        var currentState = sessionStorage.getItem("closeNotification");      
        currentState = (currentState) ? (currentState === "true") : true;
        ServiceCalls.getActiveSiteNotifications().then(function (data) {
            if (data.length > 0) {   
                var notificationId = null;
                var currentNotification = {};
                //US7094559 - If GLOBAL has a notification - show it
                if (data.some(n => n.audience === "GLOBAL")) {
                    currentNotification = data.find(n => n.audience === "GLOBAL");
                    notificationId = currentNotification.notificationId;
                }
                else {
                    //US7094559 - ELSE Determine current company set ID
                    var curCompany = CommonUtils.getCurrentSupplier(currentCompanyId, currentUser);
                    if (data.some(n => n.audience === curCompany.vendorSetId)) {
                        currentNotification = data.find(n => n.audience === curCompany.vendorSetId);
                        console.log(`NOTIFICATION - Current Set Id is ${curCompany.vendorSetId} - Currently has one: ${data.some(n => n.audience === curCompany.vendorSetId)}`);
                        notificationId = currentNotification.notificationId;
                    }                    
                }
                
                sessionStorage.setItem("curNotif", notificationId);
                this.setState({
                    isOpen: currentState,
                    notification: currentNotification
                });
            }           
        }.bind(this));
    }

    dismissAlert() {
        //Save selection to local session
        sessionStorage.setItem("closeNotification", "false");
        this.setState(
            {
                isOpen: false
            });
    }

    render() {
        const alertHtml = (this.state.isOpen && this.state.notification.message) ?
            <Alert variant={this.state.notification.severity === "Error" ? "danger" : "info"} onClose={this.dismissAlert} dismissible>
                {(this.state.notification.audience === "GLOBAL")
                    ? <h6>Message from UnitedHealth Group:</h6>
                    : <h6>Message from {this.state.notification.audience}:</h6>
                }
                <p className="notificationSiteMessage">{this.state.notification.message}</p>
            </Alert> :
            <div></div>;

        return (
            <Container fluid>
                <Row>
                    <Col>
                        {alertHtml}
                    </Col>
                </Row>
            </Container>
        );
    }
}